import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const SEARCH_QUERY = gql`
  query getCompanies($where: CompanyWhereInput, $limit: Int, $offset: Int) {
    companies(where: $where, orderBy: name_asc, limit: $limit, offset: $offset) {
      items {
        id
        name
      }
    }
  }
`;

@Component({
  selector: 'fc-company-outlined-select',
  templateUrl: './fc-company-outlined-select.component.html',
})
export class FcCompanyOutlinedSelectComponent {

  @Input() public label: string;
  @Input() public required: boolean;
  @Input() public control: FormControl;

  constructor(
    public apollo: Apollo,
  ) {}

  public searchCompanies(searchTerm: string, limit: number, offset: number): Observable<any[]> {
    return this.apollo
      .query({
        query: SEARCH_QUERY,
        variables: {
          where: {
            archived: false,
            name_contains: searchTerm
          },
          limit: limit,
          offset: offset
        }
      })
      .pipe(
        map(({ data }) => {
          return data['companies']['items'];
        })
      );
  }
}
